export default "__VITE_ASSET__Ca06ZSAS__"